
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import * as base64 from 'base-64';

export interface ISignInPayload {
    username: string;
    password: string;
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    user: FormGroup;
    validated: boolean;

    constructor() { }

    ngOnInit() {
        const self = this;
        self.initialiseAccountSignInForm();
    }

    initialiseAccountSignInForm() {
        const self = this;
        self.user = new FormGroup({
            username: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            password: new FormControl('', Validators.required)
        });
        return true;
    }

    accountSignIn({ value, valid }: { value: ISignInPayload; valid: boolean }) {
        const self = this;
        self.validated = true;
        return (valid === true ? self.authenticateUser(value) : self.validateUserSignInForm());
    }

    authenticateUser(value: ISignInPayload): boolean {
        const self = this;
        const oauthCode: string = self.getOauthCode(value);
        const concatenatedURL: string = self.getConcatenatedURL(oauthCode);
        return self.redirect(concatenatedURL);
    }

    redirect(concatenatedURL: string): boolean {
        window.location.href = concatenatedURL;
        return true;
    }

    getOauthCode(value: ISignInPayload): string {
        // const hashedPassword: string = SHA512(value.password).toString();
        // We no longer hash passwords before sending them in.
        const {
            username,
            password
        } = value;
        const oauthCode: string = base64.encode(`${username}:${password}`);
        return oauthCode;
    }

    validateUserSignInForm() {
        const self = this;
        for (let i in self.user.controls) {
            self.user.controls[i].markAsTouched();
            self.user.controls[i].updateValueAndValidity();
        }
        return false;
    }

    getConcatenatedURL(oauthCode: string): string {
        const self = this;
        const webUrl: any = self.getWebLocationUrl();
        const stateParams: string = self.searchURLParams(webUrl, "state");
        console.log('stateParams', stateParams);
        const redirectUriParams: string = self.searchURLParams(webUrl, "redirect_uri");
        console.log('redirectUriParams', redirectUriParams);
        const responseTypeParams: string = self.searchURLParams(webUrl, "response_type");
        console.log('responseTypeParams', responseTypeParams);
        const concatenatedURL: string = `${redirectUriParams}?state=${stateParams}&redirect_uri=${redirectUriParams}&response_type=${responseTypeParams}&code=${oauthCode}`;
        console.log('concatenatedURL', concatenatedURL);
        return concatenatedURL;
    }

    getWebLocationUrl() {
        return window.location;
    }

    searchURLParams(url: string, toSearch: string) {
        const link = new URL(url)
        var result = link.searchParams.get(toSearch)
        return result;
    }

    onKeyup(event: any, formControl: AbstractControl) {
        if (event.key !== 'Tab' && event.key !== 'Enter') {
            // formControl.setErrors(null);
        }
    }

    onBlur(control: AbstractControl) {
        const self = this;
        control.markAsUntouched();
    }

    get username() {
        return this.user.get('username');
    }
    get password() {
        return this.user.get('password');
    }
}